import { render, staticRenderFns } from "./EdjsInput.vue?vue&type=template&id=36e6d5f1"
import script from "./EdjsInput.vue?vue&type=script&lang=js"
export * from "./EdjsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports